<script lang="ts" setup>
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
  (e: 'submit'): void;
}>();

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(value): void {
    emit('update:modelValue', value);
  },
});

function submit() {
  emit('submit');
}
</script>

<template>
  <form class="flex leading-1 justify-end" @submit.prevent="submit">
    <input
      v-model.trim="localValue"
      class="border border-gray-300 rounded-md rounded-r-none px-5 py-2 w-full md:w-80"
      :placeholder="placeholder"
    />

    <button
      class="flex border border-gray-300 border-l-0 rounded-md rounded-l-none px-5 py-2 shrink-0"
    >
      <MagnifyIcon class="shrink-0" :size="20" /><span>検索</span>
    </button>
  </form>
</template>
